import {mapFieldContract} from '../../core/fieldContract';

/**
 * Convert allowlisted canonical SSID values to existing Canvas form state.
 * Unknown keys are intentionally ignored.
 * @param {object} values canonical agent values
 * @param {boolean} tip whether the mounted form is a TIP SSID form
 * @return {object} safe Canvas field patch
 */
export function mapSsidPrefill(values = {}, tip = false) {
	const contractPatch = mapFieldContract(values, tip);
	if (contractPatch !== null) return contractPatch;

	const patch = {};
	const suffix = tip ? 'Tip' : '';
	if (typeof values.ssid_name === 'string') {
		patch[`ssidName${suffix}`] = values.ssid_name;
	}
	const securityType = values.security_type_frontend_value;
	if (securityType != null && String(securityType).trim()) {
		patch[`securityType${suffix}`] = String(securityType).trim();
	}
	if (typeof values.passphrase === 'string') {
		patch[`pskKey${suffix}`] = values.passphrase;
	}
	if (
		values.aaa_server_id != null &&
		String(values.aaa_server_id).trim()
	) {
		patch[`AAAServer${suffix}`] = String(values.aaa_server_id).trim();
	}
	if (
		!tip &&
		values.multi_psk_id != null &&
		String(values.multi_psk_id).trim()
	) {
		patch.multiPsk = String(values.multi_psk_id).trim();
	}
	if (typeof values.hidden === 'boolean') {
		patch[`hideSSID${suffix}`] = values.hidden;
	}
	if (typeof values.client_isolation === 'boolean') {
		patch[`clientIsolation${suffix}`] = values.client_isolation;
	}
	if (!tip && typeof values.nas_id === 'string' && values.nas_id.trim()) {
		patch.nasId = true;
		patch.nasIdText = values.nas_id.trim();
	}
	if (
		Number.isInteger(values.vlan_id) &&
		values.vlan_id >= 1 &&
		values.vlan_id <= 4094
	) {
		patch[`vlanCheckbox${suffix}`] = true;
		patch[`vlanId${suffix}`] = String(values.vlan_id);
	}
	return patch;
}
